import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={23.299}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22360 20270"
    {...props}
  >
    <defs>
      <style>{".fil1{fill:#1c1b17}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974600265408">
        <path
          d="M6040 19784h14274v-2918H6040c-1453 0-2636-1182-2636-2636 0-1453 1183-2636 2636-2636h10280c3062 0 5554-2492 5554-5554 0-3063-2492-5554-5554-5554H2046v2918h14274c1453 0 2636 1182 2636 2636 0 1453-1183 2636-2636 2636H6040c-3062 0-5554 2492-5554 5554 0 3063 2491 5554 5554 5554zm14760-2918v649h1317c134 0 243 108 243 243 0 134-109 243-243 243h-1317v648h1317c134 0 243 109 243 243 0 135-109 243-243 243h-1317v649h1317c134 0 243 109 243 243s-109 243-243 243H6040C2709 20270 0 17560 0 14230s2709-6040 6040-6040h10280c1185 0 2150-964 2150-2150s-965-2150-2150-2150H243c-134 0-243-109-243-243 0-135 109-243 243-243h1317v-649H243c-134 0-243-109-243-243s109-243 243-243h1317v-649H243c-134 0-243-108-243-243 0-134 109-243 243-243h1317V486H243C109 486 0 377 0 243S109 0 243 0h16077c3330 0 6040 2709 6040 6040s-2710 6040-6040 6040H6040c-1185 0-2150 964-2150 2150 0 1185 964 2150 2150 2150h16077c134 0 243 109 243 243 0 135-109 243-243 243h-1317zM18613 2248l-141 213 141-213z"
          style={{
            fill: "#2b2a29",
          }}
          className="fill"
        />
        <g id="_1974600219872">
          <circle cx={3078} cy={2115} r={493} className="fil1" />
          <rect
            width={471}
            height={1196}
            x={4660}
            y={1499}
            className="fil1"
            rx={658}
            ry={658}
          />
        </g>
        <g id="_1974600218688">
          <circle cx={6695} cy={2115} r={493} className="fil1" />
          <rect
            width={471}
            height={1196}
            x={8277}
            y={1499}
            className="fil1"
            rx={658}
            ry={658}
          />
        </g>
        <g id="_1974600215424">
          <circle cx={10312} cy={2115} r={493} className="fil1" />
          <rect
            width={471}
            height={1196}
            x={11894}
            y={1499}
            className="fil1"
            rx={658}
            ry={658}
          />
        </g>
        <g id="_1974600216448">
          <circle cx={13601} cy={2115} r={493} className="fil1" />
          <rect
            width={471}
            height={1196}
            x={15183}
            y={1499}
            className="fil1"
            rx={658}
            ry={658}
          />
        </g>
        <circle cx={16889} cy={2115} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          className="fil1"
          rx={658}
          ry={658}
          transform="rotate(45 7100.192 23410.889)"
        />
        <circle cx={19519} cy={3431} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          className="fil1"
          rx={658}
          ry={658}
          transform="rotate(90 8063.645 12555.655)"
        />
        <rect
          width={471}
          height={1196}
          className="fil1"
          rx={658}
          ry={658}
          transform="rotate(90 7406.005 13213.295)"
        />
        <circle cx={20021} cy={7376} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          className="fil1"
          rx={658}
          ry={658}
          transform="rotate(120 7468.417 10157.53)"
        />
        <circle cx={18377} cy={9678} r={493} className="fil1" />
        <g id="_1974600208992">
          <rect
            width={471}
            height={1196}
            x={16497}
            y={9391}
            className="fil1"
            rx={658}
            ry={658}
          />
          <circle cx={15089} cy={10007} r={493} className="fil1" />
        </g>
        <rect
          width={471}
          height={1196}
          x={13209}
          y={9391}
          className="fil1"
          rx={658}
          ry={658}
        />
        <circle cx={11801} cy={10007} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          x={9921}
          y={9391}
          className="fil1"
          rx={658}
          ry={658}
        />
        <circle cx={8512} cy={10007} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          x={6632}
          y={9391}
          className="fil1"
          rx={658}
          ry={658}
        />
        <circle cx={5224} cy={10007} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          className="fil1"
          rx={658}
          ry={658}
          transform="rotate(-45 14037.135 1586.052)"
        />
        <circle cx={2594} cy={11980} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          className="fil1"
          rx={658}
          ry={658}
          transform="rotate(-90 7589.36 5923.64)"
        />
        <rect
          width={471}
          height={1196}
          className="fil1"
          rx={658}
          ry={658}
          transform="rotate(-90 8082.61 6416.89)"
        />
        <circle cx={2265} cy={15926} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          className="fil1"
          rx={658}
          ry={658}
          transform="rotate(45 -18324.845 12548.863)"
        />
        <circle cx={4567} cy={18227} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          x={5973}
          y={17629}
          className="fil1"
          rx={658}
          ry={658}
        />
        <circle cx={7855} cy={18227} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          x={9261}
          y={17629}
          className="fil1"
          rx={658}
          ry={658}
        />
        <circle cx={11143} cy={18227} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          x={12550}
          y={17629}
          className="fil1"
          rx={658}
          ry={658}
        />
        <circle cx={14431} cy={18227} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          x={15838}
          y={17629}
          className="fil1"
          rx={658}
          ry={658}
        />
        <circle cx={17719} cy={18227} r={493} className="fil1" />
        <rect
          width={471}
          height={1196}
          x={19126}
          y={17629}
          className="fil1"
          rx={658}
          ry={658}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
